import {Component} from '@angular/core';
import {AbstractQuillToolbarButtonComponent} from '../abstract-quill-toolbar-button';

/**
 * Class for the UndoQuillToolbarButtonComponent
 * @class
 * @extends AbstractQuillToolbarButtonComponent
 *
 * @example
 *
 * ```html
 * <advtech-undo-quill-toolbar-button #customButton></advtech-undo-quill-toolbar-button>
 * ```
 */
@Component({
  selector: 'advtech-undo-quill-toolbar-button',
  templateUrl: './undo-quill-toolbar-button.component.html',
})
export class UndoQuillToolbarButtonComponent extends AbstractQuillToolbarButtonComponent {

  /** @inheritdoc */
  hClick() {
    this.quill.getModule('history').undo();
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/undo-quill-toolbar-button/undo-quill-toolbar-button.component.ts